type Account = {
  id: string
  name: string
  mask: string
  type: string
  subtype: string
  verification_status: string
}

export const includesCurrentAccount = (accounts: Account[]) => {
  const filteredAccounts = accounts.filter(
    (account: Account) => account.type === 'depository' && account.subtype === 'checking',
  )

  return filteredAccounts.length > 0
}
